import { useTranslation } from 'react-i18next';

import type { LeaderboardEntry } from '../features/leaderboard/leaderboardApi';
import './LeaderboardTable.css';

interface LeaderboardTableProps {
  entries: LeaderboardEntry[];
}

/** Ranked standings table for the instructor leaderboard (US7, FR-044 to FR-049). */
function LeaderboardTable({ entries }: LeaderboardTableProps) {
  const { t } = useTranslation();

  if (entries.length === 0) {
    return <p className="leaderboard-table__empty">{t('leaderboard.empty')}</p>;
  }

  return (
    <table className="leaderboard-table">
      <thead>
        <tr>
          <th>{t('leaderboard.columnRank')}</th>
          <th>{t('leaderboard.columnStudent')}</th>
          <th>{t('leaderboard.columnPoints')}</th>
        </tr>
      </thead>
      <tbody>
        {entries.map((entry) => (
          <tr
            key={entry.userId}
            className={entry.rank === 1 ? 'leaderboard-table__row--leader' : undefined}
          >
            <td>{entry.rank}</td>
            <td>
              <span className="leaderboard-table__student">
                {entry.displayName}
                {entry.displayBadge ? (
                  <span className="leaderboard-table__badge">
                    <img
                      src={entry.displayBadge.imageUrl}
                      alt={t(`badges.catalog.${entry.displayBadge.badgeCode}.altText`, {
                        defaultValue: entry.displayBadge.altText,
                      })}
                    />
                    {t(`badges.catalog.${entry.displayBadge.badgeCode}.name`, {
                      defaultValue: entry.displayBadge.name,
                    })}
                  </span>
                ) : null}
              </span>
            </td>
            <td>{entry.totalPoints}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

export default LeaderboardTable;
